const SERVICE_PREVIEW_DATA = [
    {
        id: 1,
        title: "Manicure",
        description: "30 - 60 Minute Sessions",
        price: 40
    },
    {
        id: 2,
        title: "Regular Pedicure",
        description: "30 - 60 Minute Sessions",
        price: 28
    },
    {
        id: 3,
        title: "Deluxe Pedicure",
        description: "40 - 70 Minute Sessions",
        price: 38
    },
    {
        id: 4,
        title: "Acrylic Fills",
        description: "15 - 30 Minute Sessions",
        price: 23
    },
    {
        id: 5,
        title: "Eyebrow Waxing",
        description: "25 - 35 Minute Sessions",
        price: 14
    },
    {
        id: 6,
        title: "Full Face Waxing",
        description: "35 - 50 Minute Sessions",
        price: 48
    },
]

export default SERVICE_PREVIEW_DATA